import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { OPS_HUB_ROUTE_PATHS } from '../config';

export const GATEWAY_ROUTING_ROUTES: TApplicationRoute[] = [
  {
    id: 'ops-hub-gateway-routing',
    path: OPS_HUB_ROUTE_PATHS.gatewayRouting,
    component: lazy(() => import('./pages/gateway-routing-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['gateway-routing'] },
    menu: {
      title: 'Gateway Routing',
    },
  },
];
